import React, { useEffect, useState, useCallback, lazy, Suspense } from 'react';
import '@/App.css';
import './styles/themes.css';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import FCMNotificationManager from './components/FCMNotificationBanner';
import axios from 'axios';

// الصفحات الأساسية (تحميل فوري)
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import LanguageSelector from './components/LanguageSelector';

// الصفحات الثقيلة (تحميل كسول)
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const LawyerDashboard = lazy(() => import('./pages/LawyerDashboard'));
const AccountantDashboard = lazy(() => import('./pages/AccountantDashboard'));
const PartnerDashboard = lazy(() => import('./pages/PartnerDashboard'));
const MarketerDashboard = lazy(() => import('./pages/MarketerDashboard'));
const StaffDashboard = lazy(() => import('./pages/StaffDashboard'));
const MarketAnalysisChart = lazy(() => import('./pages/MarketAnalysisChart'));
const MarketerAppointments = lazy(() => import('./pages/MarketerAppointments'));
const Clients = lazy(() => import('./pages/Clients'));
const ClientProfile = lazy(() => import('./pages/ClientProfile'));
const PartnerProfile = lazy(() => import('./pages/PartnerProfile'));
const ClientProfiles = lazy(() => import('./pages/ClientProfiles'));
const Cases = lazy(() => import('./pages/Cases'));
const LegalLibrary = lazy(() => import('./pages/LegalLibrary'));
const LegalLibraryNew = lazy(() => import('./pages/LegalLibraryNew'));
const WorkScheduleTables = lazy(() => import('./pages/WorkScheduleTablesNew'));
const EngineeringConsultationForm = lazy(() => import('./pages/EngineeringConsultation'));
const FinancialRestructuringUI = lazy(() => import('./pages/FinancialRestructuring'));
// const LegalFeeContract = lazy(() => import('./components/LegalFeeContract'));
const RemoteContractSigning = lazy(() => import('./pages/RemoteContractSigning'));
const WorkArchive = lazy(() => import('./pages/WorkArchive'));
const WorkFlow = lazy(() => import('./pages/WorkFlow'));
const PartnerDynamicPage = lazy(() => import('./pages/PartnerDynamicPage'));
const HukmCaseViewer = lazy(() => import('./pages/HukmCaseViewer'));
const PartnerCaseViewer = lazy(() => import('./pages/PartnerCaseViewer'));
const ElectronicContract = lazy(() => import('./pages/ElectronicContract'));
// تحميل كسول لجميع الصفحات الثقيلة
const GuestConsultation = lazy(() => import('./pages/GuestConsultation'));
const GuestNotaryService = lazy(() => import('./pages/GuestNotaryService'));
const VirtualCourt = lazy(() => import('./pages/VirtualCourt'));
const VirtualCourtLanding = lazy(() => import('./pages/VirtualCourtLanding'));
const UniversityDashboard = lazy(() => import('./pages/UniversityDashboard'));
const DemoPortal = lazy(() => import('./pages/DemoPortal'));
const InternshipPlatform = lazy(() => import('./pages/InternshipPlatform'));
const VirtualCourtShop = lazy(() => import('./pages/VirtualCourtShop'));
const ArbitratorPanel = lazy(() => import('./pages/ArbitratorPanel'));
const PartiesDashboard = lazy(() => import('./pages/PartiesDashboard'));
const StudentDashboard = lazy(() => import('./pages/StudentDashboard'));
const CertificateVerify = lazy(() => import('./pages/CertificateVerify'));
const ArbitratorDashboard = lazy(() => import('./pages/ArbitratorDashboard'));
// const ClientRequests = lazy(() => import('./pages/ClientRequests'));
const ClientRequestsAdmin = lazy(() => import('./pages/ClientRequestsAdmin'));
const EmployeeClientRequests = lazy(() => import('./pages/EmployeeClientRequests'));
const EscrowOrderView = lazy(() => import('./pages/EscrowOrderView'));
const StaffRequestsManager = lazy(() => import('./pages/StaffRequestsManager'));
const EscrowMyOrders = lazy(() => import('./pages/EscrowMyOrders'));
const PartnerWallet = lazy(() => import('./pages/PartnerWallet'));
const PartnerEscrowTasks = lazy(() => import('./pages/PartnerEscrowTasks'));
const AdminEscrowDashboard = lazy(() => import('./pages/AdminEscrowDashboard'));
const AdminB2BEnterprises = lazy(() => import('./pages/AdminB2BEnterprises'));
const Appointments = lazy(() => import('./pages/Appointments'));
const Invoices = lazy(() => import('./pages/Invoices'));
const Consultations = lazy(() => import('./pages/Consultations'));
const Documents = lazy(() => import('./pages/Documents'));
// const CreateUser = lazy(() => import('./components/CreateUser'));
const Employees = lazy(() => import('./pages/Employees'));
const EmployeesManagement = lazy(() => import('./pages/EmployeesManagement'));
const EditUser = lazy(() => import('./pages/EditUser'));
const Assignments = lazy(() => import('./components/Assignments'));
const ChangePassword = lazy(() => import('./pages/ChangePassword'));
const Fees = lazy(() => import('./pages/Fees'));
const Vouchers = lazy(() => import('./pages/Vouchers'));
const FinancialReports = lazy(() => import('./pages/FinancialReports'));
const Meetings = lazy(() => import('./pages/Meetings'));
const Attendance = lazy(() => import('./pages/Attendance'));
const Reports = lazy(() => import('./pages/Reports'));
const CasesTable = lazy(() => import('./pages/CasesTable'));
const WorkScheduleSettings = lazy(() => import('./pages/WorkScheduleSettings'));
const LegalAI = lazy(() => import('./pages/LegalAI'));
const MyAssignedTasks = lazy(() => import('./pages/MyAssignedTasks'));
const TaskReports = lazy(() => import('./pages/TaskReports'));
const EmailInbox = lazy(() => import('./pages/EmailInbox'));
const EmployeeScheduleManagement = lazy(() => import('./pages/EmployeeScheduleManagement'));
const AccountSettings = lazy(() => import('./pages/AccountSettings'));
const VideoMeetings = lazy(() => import('./pages/VideoMeetings'));
const EnterpriseDashboard = lazy(() => import('./pages/EnterpriseDashboard'));
const MarketerPackages = lazy(() => import('./pages/MarketerPackages'));
const PaymentPage = lazy(() => import('./pages/PaymentPage'));
// const CaseStudyForm = lazy(() => import('./components/CaseStudyForm'));
const DownloadApp = lazy(() => import('./pages/DownloadApp'));
const ConsultantDashboard = lazy(() => import('./pages/ConsultantDashboard'));
const CaseReferralManager = lazy(() => import('./pages/CaseReferralManager'));
const IndividualClientDashboard = lazy(() => import('./pages/IndividualClientDashboard'));
const ServicePricingManager = lazy(() => import('./pages/ServicePricingManager'));
const MeetingRequests = lazy(() => import('./pages/MeetingRequests'));
const PartnerMeeting = lazy(() => import('./pages/PartnerMeeting'));
const QuoteRequestsManager = lazy(() => import('./pages/QuoteRequestsManager'));
const AnnouncementsManager = lazy(() => import('./pages/AnnouncementsManager'));
const InvestmentServicesManager = lazy(() => import('./pages/InvestmentServicesManager'));
const InvestmentServicesClient = lazy(() => import('./pages/InvestmentServicesClient'));
const AamalySearchPage = lazy(() => import('./pages/AamalySearchPage'));
const SidebarManager = lazy(() => import('./pages/SidebarManager'));
const DepartmentsManager = lazy(() => import('./pages/DepartmentsManager'));
const RolesPermissionsManager = lazy(() => import('./pages/RolesPermissionsManager'));
const PayrollManager = lazy(() => import('./pages/PayrollManager'));
const NotificationsPage = lazy(() => import('./pages/NotificationsPage'));
const ContractManagement = lazy(() => import('./pages/ContractManagement'));
const ContractsManager = lazy(() => import('./pages/ContractsManager'));
const PartnerContractView = lazy(() => import('./pages/PartnerContractView'));
const AdminThemes = lazy(() => import('./pages/AdminThemes'));

// مكونات تُحمّل مباشرة (صغيرة الحجم)
// import VirtualAssistant from './components/VirtualAssistant';
import ThemeToggle from './components/ThemeToggle';
import PWAInstallButton from './components/PWAInstallButton';
import MobileBottomNav from './components/MobileBottomNav';
// import MobileQuickActions from './components/MobileQuickActions';
// import AudioNotificationSystem from './components/AudioNotification';

// مكون التحميل المحسّن
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-sand dark:bg-slate-900">
    <div className="text-center">
      <div className="relative">
        <div className="animate-spin w-16 h-16 border-4 border-gold/30 border-t-gold rounded-full mx-auto"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 bg-gold/20 rounded-full animate-pulse"></div>
        </div>
      </div>
      <p className="text-gray-500 dark:text-gray-400 mt-4 font-body text-sm">جاري التحميل...</p>
    </div>
  </div>
);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// دوال مساعدة لقراءة localStorage بأمان
export const safeGetUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr || userStr === 'undefined' || userStr === 'null') {
      return null;
    }
    return JSON.parse(userStr);
  } catch (e) {
    console.error('Error parsing user from localStorage:', e);
    localStorage.removeItem('user');
    return null;
  }
};

export const safeGetToken = () => {
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };
  const token = getCookie('csrf_token') || (document.cookie.split('; ').find(row => row.startsWith('csrf_token='))?.split('=')[1] || '');
  if (!token || token === 'undefined' || token === 'null') {
    return null;
  }
  return token;
};

function PrivateRoute({ children }) {
  const token = safeGetToken();
  return token ? children : <Navigate to="/login" />;
}

const isHukmDomain = window.location.hostname.includes('hukm.cloud');
// <Route path="/" element={<LandingPage />} />

function App() {
  // الحصول على معلومات المستخدم للقائمة السفلية
  const [currentUser, setCurrentUser] = useState(null);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  
  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr && userStr !== 'undefined' && userStr !== 'null') {
      try {
        setCurrentUser(JSON.parse(userStr));
      } catch (e) {
        console.error('Error parsing user:', e);
      }
    }
  }, []);
  // useEffect(() => {
  //   // تأكد من وضع أسماء الدومينات الخاصة بك هنا
  //   if (isHukmDomain) {
  //     // 1. تغيير العنوان
  //     document.title = "المحكمة الافتراضية";

  //     // تغيير المانيفست (هذا هو المفتاح لحل مشكلة أيقونة التطبيق)
  //     const manifest = document.querySelector('link[rel="manifest"]');
  //     if (manifest) {
  //       manifest.setAttribute("href", "/manifest-hukm.json");
  //     }
      
  //     // 2. تغيير اللوغو (Favicon)
  //     const favicon = document.querySelector('link[rel="icon"]');
  //     if (favicon) favicon.href = "/hukm-cloud-icon.svg"; // ارفع الصورة في مجلد public
      
  //     const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  //     if (appleIcon) appleIcon.href = "/hukm-cloud-icon.svg";

  //     // تغيير اسم التطبيق عند التثبيت (PWA Title)
  //     const appTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  //     if (appTitle) appTitle.setAttribute("content", "المحكمة الافتراضية");

  //     const appName = document.querySelector('meta[name="application-name"]');
  //     if (appName) appName.setAttribute("content", "المحكمة الافتراضية");

  //     // 3. تغيير ثيم اللون إذا أردت
  //     // const themeColor = document.querySelector('meta[name="theme-color"]');
  //     // if (themeColor) themeColor.setAttribute("content", "#your-new-color");
  //   }
  // }, []);

  // تحديد نوع المستخدم للقائمة السفلية
  const getUserRole = () => {
    if (!currentUser) return 'client';
    if (currentUser.role) return currentUser.role;
    if (currentUser.account_type === 'company' || currentUser.client_type === 'company') return 'company';
    return 'individual';
  };

    // Handle new FCM notification received
  const handleNotificationReceived = useCallback((message) => {
    // console.log('New FCM notification:', message);
    // Increment unread count
    setUnreadNotifications(prev => prev + 1);
  }, []);

  return (
    <LanguageProvider>
    <div className="App">
      <FCMNotificationManager onNotificationReceived={handleNotificationReceived} />
      <BrowserRouter>
    <ThemeProvider>
      <ThemeToggle />
        <Suspense fallback={<LoadingSpinner />}>
        {isHukmDomain ? (
          <Routes>
            <Route path="/" element={<VirtualCourtLanding />} />
            <Route path="/virtual-court" element={<VirtualCourtLanding />} />
            <Route path="/virtual-court/arbitrator-panel" element={<ArbitratorPanel />} />
            <Route path="/virtual-court/parties" element={<PartiesDashboard />} />
            <Route path="/virtual-court/arbitrator" element={<ArbitratorDashboard />} />
            <Route path="/virtual-court/university" element={<UniversityDashboard />} />
            <Route path="/virtual-court/demo" element={<DemoPortal />} />
            <Route path="/virtual-court/shop" element={<VirtualCourtShop />} />
            <Route path="/virtual-court/courtroom" element={<VirtualCourt />} />
            <Route path="/virtual-court/prosecutor" element={<VirtualCourt />} />
            <Route path="/virtual-court/litigation" element={<VirtualCourt />} />
            <Route path="/virtual-court/training" element={<VirtualCourt />} />
            <Route path="/virtual-court/student" element={<StudentDashboard />} />
            <Route path="/verify-cert/:certNumber" element={<CertificateVerify />} />
             <Route path="/legal-library/ai" element={<LegalAI />} />
            <Route path="/legal-library" element={<LegalLibraryNew />} />
            <Route path="/internship" element={<InternshipPlatform />} />
            <Route path="*" element={<VirtualCourtLanding />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/download" element={<DownloadApp />} />
            <Route path="/guest-consultation" element={<GuestConsultation />} />
            <Route path="/guest-notary" element={<GuestNotaryService />} />
            <Route path="/legal-library" element={<LegalLibraryNew />} />
            <Route
              path="/notifications"
              element={
                <PrivateRoute>
                  <NotificationsPage />
                </PrivateRoute>
              }
            />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardRouter />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner/:partner"
            element={
              <PrivateRoute>
                <PartnerDynamicPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases"
            element={
              <PrivateRoute>
                <Cases />
              </PrivateRoute>
            }
          />
            <Route
            path="/financial-restructuring"
            element={
              <PrivateRoute>
                <FinancialRestructuringUI />
              </PrivateRoute>
            }
          />
            <Route
            path="/engineering-consultation"
            element={
              <PrivateRoute>
                <EngineeringConsultationForm />
              </PrivateRoute>
            }
          />
           <Route
            path="/market-analysis-chart"
            element={
              <PrivateRoute>
                <MarketAnalysisChart />
              </PrivateRoute>
            }
          />
          <Route
            path="/marketer-appointments"
            element={
              <PrivateRoute>
                <MarketerAppointments />
              </PrivateRoute>
            }
          />
          <Route
            path="/electronic-contract"
            element={
              <PrivateRoute>
                <ElectronicContract />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases-viewer/:caseId?"
            element={
              <PrivateRoute>
                {(() => {
                  const role = getUserRole();
                  // أضفنا التحقق هنا للتأكد من أن المكونات معرفة
                  if (role === "partner") {
                    return typeof PartnerCaseViewer !== 'undefined' ? <PartnerCaseViewer /> : <div className='flex items-center justify-center min-h-screen'><p className='text-2xl text-center'>please load the page again - من فضلك اعد تحميل الصفحة</p></div>;
                  }
                  return <HukmCaseViewer />;
                })()}
              </PrivateRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <PrivateRoute>
                <Appointments />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <Invoices />
              </PrivateRoute>
            }
          />
          <Route
            path="/consultations"
            element={
              <PrivateRoute>
                <Consultations />
              </PrivateRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <PrivateRoute>
                <Documents />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <Clients />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/:clientId/profile"
            element={
              <PrivateRoute>
                <ClientProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner-profile"
            element={
              <PrivateRoute>
                <PartnerProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner-profile"
            element={
              <PrivateRoute>
                <PartnerProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner-meeting"
            element={
              <PrivateRoute>
                <PartnerMeeting />
              </PrivateRoute>
            }
          />
          <Route
            path="/edit-user/:userId"
            element={
              <PrivateRoute>
                <EditUser />
              </PrivateRoute>
            }
          />
          <Route
            path="/client-profiles"
            element={
              <PrivateRoute>
                <ClientProfiles />
              </PrivateRoute>
            }
          />
          <Route
            path="/contracts"
            element={
              <PrivateRoute>
                <ContractsManager />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/client-requests"
            element={
              <PrivateRoute>
                <ClientRequests />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/admin/client-requests"
            element={
              <PrivateRoute>
                <ClientRequestsAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/employee/client-requests"
            element={
              <PrivateRoute>
                <ClientRequestsAdmin />
              </PrivateRoute>
            }
          />
          {/* منصة إنجاز — نظام الأمانة */}
          <Route
            path="/escrow"
            element={
              <PrivateRoute>
                <EscrowMyOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/escrow/order/:orderId"
            element={
              <PrivateRoute>
                <EscrowOrderView />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner/tasks"
            element={
              <PrivateRoute>
                <PartnerEscrowTasks />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner/wallet"
            element={
              <PrivateRoute>
                <PartnerWallet />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/escrow"
            element={
              <PrivateRoute>
                <AdminEscrowDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/b2b-enterprises"
            element={
              <PrivateRoute>
                <AdminB2BEnterprises />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/create-user"
            element={
              <PrivateRoute>
                <CreateUser />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/employees"
            element={
              <PrivateRoute>
                <EmployeesManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/employee-schedule"
            element={
              <PrivateRoute>
                <EmployeeScheduleManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff-dashboard"
            element={
              <PrivateRoute>
                <StaffDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/accountant"
            element={
              <PrivateRoute>
                <AccountantDashboard />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/case-study"
            element={
              <PrivateRoute>
                <CaseStudyForm />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/assignments"
            element={
              <PrivateRoute>
                <Assignments />
              </PrivateRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <PrivateRoute>
                <Attendance />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases-table"
            element={
              <PrivateRoute>
                <CasesTable />
              </PrivateRoute>
            }
          />
          <Route
            path="/work-schedule"
            element={
              <PrivateRoute>
                <WorkScheduleSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/meetings"
            element={
              <PrivateRoute>
                <Meetings />
              </PrivateRoute>
            }
          />
          <Route
            path="/fees"
            element={
              <PrivateRoute>
                <Fees />
              </PrivateRoute>
            }
          />
          <Route
            path="/vouchers"
            element={
              <PrivateRoute>
                <Vouchers />
              </PrivateRoute>
            }
          />
          <Route
            path="/financial-reports"
            element={
              <PrivateRoute>
                <FinancialReports />
              </PrivateRoute>
            }
          />
          <Route
            path="/legal-library"
            element={
              <PrivateRoute>
                <LegalLibrary />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/legal-contracts"
            element={
              <PrivateRoute>
                <LegalFeeContract />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/sign-contract/:token"
            element={<RemoteContractSigning />}
          />
          <Route
            path="/work-archive"
            element={
              <PrivateRoute>
                <WorkArchive />
              </PrivateRoute>
            }
          />
          <Route
            path="/work-flow"
            element={
              <PrivateRoute>
                <WorkFlow />
              </PrivateRoute>
            }
          />
          <Route
            path="/legal-library/ai"
            element={
              <PrivateRoute>
                <LegalAI />
              </PrivateRoute>
            }
          />
          <Route
            path="/my-tasks"
            element={
              <PrivateRoute>
                <MyAssignedTasks />
              </PrivateRoute>
            }
          />
          <Route
            path="/task-reports"
            element={
              <PrivateRoute>
                <TaskReports />
              </PrivateRoute>
            }
          />
          <Route
            path="/work-schedules"
            element={
              <PrivateRoute>
                <WorkScheduleTables />
              </PrivateRoute>
            }
          />
          <Route
            path="/emails/*"
            element={
              <PrivateRoute>
                <EmailInbox />
              </PrivateRoute>
            }
          />
          <Route
            path="/email-inbox"
            element={
              <PrivateRoute>
                <EmailInbox />
              </PrivateRoute>
            }
          />
          <Route
            path="/marketer"
            element={
              <PrivateRoute>
                <MarketerDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/account-settings"
            element={
              <PrivateRoute>
                <AccountSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/video-meetings"
            element={
              <PrivateRoute>
                <VideoMeetings />
              </PrivateRoute>
            }
          />
          <Route
            path="/marketer/packages"
            element={
              <PrivateRoute>
                <MarketerPackages />
              </PrivateRoute>
            }
          />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment/success" element={<PaymentPage />} />
          <Route path="/payment/cancel" element={<PaymentPage />} />
          <Route path="/payment/callback" element={<PaymentPage />} />
          <Route
            path="/service-pricing"
            element={
              <PrivateRoute>
                <ServicePricingManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/meeting-requests"
            element={
              <PrivateRoute>
                <MeetingRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/quote-requests"
            element={
              <PrivateRoute>
                <QuoteRequestsManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/announcements"
            element={
              <PrivateRoute>
                <AnnouncementsManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/investment-services-admin"
            element={
              <PrivateRoute>
                <InvestmentServicesManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/investment-services"
            element={
              <PrivateRoute>
                <InvestmentServicesClient />
              </PrivateRoute>
            }
          />
          <Route
            path="/aamaly-search"
            element={
              <PrivateRoute>
                <AamalySearchPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/sidebar-manager"
            element={
              <PrivateRoute>
                <SidebarManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/departments-manager"
            element={
              <PrivateRoute>
                <DepartmentsManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/roles-permissions"
            element={
              <PrivateRoute>
                <RolesPermissionsManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/payroll"
            element={
              <PrivateRoute>
                <PayrollManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/contracts"
            element={
              <PrivateRoute>
                <ContractManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/partner/contract/:contractId"
            element={
              <PrivateRoute>
                <PartnerContractView />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/themes"
            element={
              <PrivateRoute>
                <AdminThemes />
              </PrivateRoute>
            }
          />
          <Route
            path="/consultant-dashboard"
            element={
              <PrivateRoute>
                <ConsultantDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/case-referrals"
            element={
              <PrivateRoute>
                <CaseReferralManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/staff-requests"
            element={
              <PrivateRoute>
                <StaffRequestsManager />
              </PrivateRoute>
            }
          />
        </Routes>
        )}
        </Suspense>
        {/* المساعد الافتراضي - يظهر في جميع الصفحات */}
        {/* نتحقق أولاً من وجود المستخدم، ثم نتحقق أن دوره ليس ضمن القائمة المحظورة */}
        {/* {currentUser && !['admin', 'marketer', 'lawyer', 'staff', 'accountant', 'consultant'].includes(getUserRole()) ? (
          <VirtualAssistant />
        ) : null} */}
        {/* زر تثبيت التطبيق PWA */}
        <PWAInstallButton />
        {/* نظام التنبيهات الصوتية */}
        {/* {currentUser && (
          <AudioNotificationSystem 
            enabled={true}
            onNewNotification={(notifications) => {
              setUnreadNotifications(prev => prev + notifications.length);
            }}
          />
        )} */}
        {/* قائمة التنقل السفلية للجوال */}
        {currentUser && (
          <MobileBottomNav 
            userRole={getUserRole()} 
            unreadNotifications={unreadNotifications}
          />
        )}
        {/* زر الإجراءات السريعة للجوال */}
        {/* {currentUser && (
          <MobileQuickActions userRole={getUserRole()} />
        )} */}
    </ThemeProvider>
      </BrowserRouter>
    </div>
    </LanguageProvider>
  );
}

function DashboardRouter() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = safeGetUser();
    const token = safeGetToken();
    // console.log("DEBUG DashboardRouter: userData =", userData, "token =", token, "document.cookie =", document.cookie);
    
    if (!token || !userData) {
      navigate('/login');
      return;
    }
    
    setUser(userData);
    if (userData.first_login) {
      navigate('/change-password');
    }
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gold"></div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  if (user.role === 'admin') {
    return <AdminDashboard />;
  } else if (user.role === 'marketer') {
    return <MarketerDashboard />;
  } else if (user.role === 'accountant') {
    return <AccountantDashboard />;
  } else if (user.role === "partner") {
    return <PartnerDashboard />
  } else if (user.role === 'consultant') {
    return <ConsultantDashboard />;
  } else if (user.role === 'lawyer' || user.role === 'staff' || user.role === 'team_leader') {
    // المحامين والموظفين وقائد الفريق - نفس لوحة التحكم
    return <LawyerDashboard />;
  } else if (user.account_type === 'company' || user.client_type === 'company') {
    // عميل منشأة - يُحول للوحة تحكم المنشآت الاحترافية
    return <EnterpriseDashboard />;
  } else {
    // عميل فرد - يُحول للوحة تحكم العميل الفرد الجديدة
    return <IndividualClientDashboard />;
  }
}

export default App;
